export const forgotPasswordConstants = {
    
    FORGOTPASSWORD_API: "/vendor/forgot-password",


};
